// Globals
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem, useForm, useWatchForm } from '@/components';
import { Button, Select } from '@/ui';
import { StyledRow } from './GoogleMerchantSyncFormStyles';

// Helpers
import {
  getGoogleMerchantSyncRunAdditionalFields,
  getMerchantSyncModeOptions,
  GoogleMerchantSyncFormFields,
  TGoogleMerchantSyncFormValues,
} from '../../helpers';

type TGoogleMerchantSyncFormProps = {
  isLoading?: boolean;
  onSubmit: (values: TGoogleMerchantSyncFormValues) => void;
  onReset?: () => void;
  initialValues?: Partial<TGoogleMerchantSyncFormValues>;
};

const GoogleMerchantSyncForm: FC<TGoogleMerchantSyncFormProps> = ({ isLoading, onSubmit, onReset, initialValues }) => {
  const [form] = useForm();
  const { t } = useTranslation();
  const syncRunMode = useWatchForm(GoogleMerchantSyncFormFields.MODE, form);

  const additionalFields = useMemo(() => getGoogleMerchantSyncRunAdditionalFields(syncRunMode, t), [t, syncRunMode]);
  const modeOptions = useMemo(() => getMerchantSyncModeOptions(t), [t]);

  return (
    <Form form={form} initialValues={initialValues} onFinish={onSubmit}>
      <FormItem label={t('label_sync_mode')} name={GoogleMerchantSyncFormFields.MODE}>
        <Select options={modeOptions} />
      </FormItem>
      {additionalFields}
      <StyledRow>
        <Button loading={isLoading} htmlType="submit" type="primary" block size="small">
          {t('btn_run_sync')}
        </Button>
        <Button onClick={onReset} htmlType="button" size="small" block>
          {t('cancel_btn')}
        </Button>
      </StyledRow>
    </Form>
  );
};

export default GoogleMerchantSyncForm;
